// src/contexts/EstadoAppContext.jsx
import React, { createContext, useState, useContext, useEffect } from 'react';

// 1. Crear el Contexto
export const EstadoAppContext = createContext();

// 2. Crear el Provider
export const EstadoAppProvider = ({ children }) => {
	// Recuperar estado de localStorage o usar 'inicial' por defecto
	const [estadoAppX, setEstadoAppX] = useState(() => {
		const savedState = localStorage.getItem('estadoAppX');
		return savedState || 'inicial';
	});

	// Persistir estado en localStorage cuando cambie
	useEffect(() => {
		localStorage.setItem('estadoAppX', estadoAppX);
	}, [estadoAppX]);

	// Escuchar evento de logout para restablecer estado
	useEffect(() => {
		const handleLogout = () => {
			console.log('🧹 EstadoAppContext: Evento logout detectado, restableciendo a inicial');
			setEstadoAppX('inicial');
		};
		
		window.addEventListener('red-logout', handleLogout);
		return () => window.removeEventListener('red-logout', handleLogout);
	}, []);
	const [selectedObra, setSelectedObra] = useState(null); // Estado para almacenar la obra seleccionada
	const [origenNavegacion, setOrigenNavegacion] = useState(null);
	console.log("ESTADO APP X---->", estadoAppX)

	// Función para cambiar el estado
	//nuevo estado para previewViabilidadTécnica
	//nuevo estado para previewInformeTecnicoObservaciones
	const cambiarEstadoApp = (nuevoEstado, opciones = {}) => {
		// Opciones puede contener { obra, origen }
		const { obra, origen } = opciones || {};		

		if (['inicial',
			'nuevo',
			'continuar_nuevo',
			'ediT',
			'edit_desde_pagos',
			'edit_desde_proyectos',
			'previewViabilidadTécnica',
			'previewInformeTecnicoObservaciones',
			'ver'].includes(nuevoEstado)) {
			setEstadoAppX(nuevoEstado);
			if (obra) {
				setSelectedObra(obra);
			}
			if (origen) {
				setOrigenNavegacion(origen);
			}
		} else {
			console.warn(`Estado no válido: ${nuevoEstado}. Los estados permitidos son 'inicial', 'nuevo', 'continuar_nuevo', 'ediT', 'edit_desde_pagos', 'edit_desde_proyectos', 'ver'.`);
		}
	};

	const contextValue = {
		estadoAppX,
		cambiarEstadoApp,
		selectedObra,
		origenNavegacion,
		setOrigenNavegacion
	};

	return (
		<EstadoAppContext.Provider value={contextValue}>
			{children}
		</EstadoAppContext.Provider>
	);
};

// 3. Crear un Custom Hook para facilitar el consumo
export const useEstadoApp = () => {
	const context = useContext(EstadoAppContext);
	if (context === undefined) {
		throw new Error('useEstadoApp debe ser usado dentro de un EstadoAppProvider');
	}
	return context;
};